/**
 * Base class for all xAPI learning events.
 * Provides a standardized structure for xAPI event tracking with learning object information.
 * All specific xAPI event types should extend this class.
 *
 * Kept in its own module so event subclasses can extend it from sibling files
 * (e.g. `xapi-events.outcomes.js`) without a circular import back through
 * `xapi-events.js`.
 *
 * @abstract
 */
export class xAPIEvent {
  /**
   * Creates a new xAPI event with the specified event type and learning object information.
   * @param {string} eventType - The xAPI event type
   * @param {Object} objectInfo - Information about the learning object
   * @param {string} objectInfo.id - Object ID
   * @param {string} objectInfo.name - Object name
   * @param {string} objectInfo.type - Object type (simulation, program, etc.)
   * @param {Object} options - Additional options
   */
  constructor(eventType, objectInfo, options = {}) {
    this.eventType = eventType;
    this.objectInfo = objectInfo;
    this.options = options;
  }

  /**
   * Gets the event data for xAPI tracking.
   * @returns {Object} Event data object
   */
  getEventData() {
    return {
      eventType: this.eventType,
      objectInfo: this.objectInfo,
      options: this.options,
    };
  }
}
